import type { MetricLabel, ValuePropResponse, ValueProposition } from '../../domain/preferences';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';

const SETTINGS_API_URL = `${BASE_API_URL}/settings`;
const COUNTRIES_SETTINGS_API_URL = `${SETTINGS_API_URL}/countries`;
const METRICS_SETTINGS_API_URL = `${SETTINGS_API_URL}/metrics`;
const VALUE_PROP_SETTINGS_API_URL = `${BASE_API_URL}/value-propositions`;

export const preferencesApi = {
  getCountriesSettings: () => HttpClient.get<number[]>(COUNTRIES_SETTINGS_API_URL),
  setCountriesSettings: (countries: number[]) => HttpClient.put(COUNTRIES_SETTINGS_API_URL, { countries }),

  getMetricsLabels: () => HttpClient.get<MetricLabel[]>(`${METRICS_SETTINGS_API_URL}/labels`),
  getMetricsSettings: () => HttpClient.get<string[]>(METRICS_SETTINGS_API_URL),
  setMetricsSettings: (metrics: string[]) => HttpClient.put(METRICS_SETTINGS_API_URL, { metrics }),
  getSuggestedMetrics: () => HttpClient.get<string[]>(`${METRICS_SETTINGS_API_URL}/default`),

  getValuePropSettings: () => HttpClient.get<ValuePropResponse>(VALUE_PROP_SETTINGS_API_URL),
  setValuePropSettings: (valueProp: ValueProposition) => HttpClient.put(VALUE_PROP_SETTINGS_API_URL, valueProp),
};
